import Vue from 'vue'
import Router from 'vue-router'
import {
  MessageBox
} from 'mint-ui';
import HelloWorld from '@/components/HelloWorld'


// 用户协议
import UserAgreement from '@/components/UserAgreement'
import College from '@/components/college'
// 邀请好友
import InviteFriends from '@/components/inviteFriends'
// 帖子详情
import PostDetail from '@/components/postDetail'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/userAgreement',
      name: 'UserAgreement',
      component: UserAgreement,
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/college',
      name: 'College',
      component: College,
      meta: {
        title: '学院'
      }
    },
    {
      path: '/inviteFriends',
      name: 'InviteFriends',
      component: InviteFriends,
      meta: {
        title: '家佳宝'
      }
    },
    {
      path: '/postDetail',
      name: 'PostDetail',
      component: PostDetail,
      meta: {
        title: '帖子详情'
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router

// 页面跳转后滚动到页面顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})


// WEBPACK FOOTER //
// ./src/router/index.js